const QueryBuilderConditions = {
    And: 'AND',
    Or: 'OR',
};

const QueryBuilderAttributeTypes = {
    Enum: 'enum',
    Date: 'date',
    Int: 'int',
    Lookup: 'lookup',
    ObjectPending: 'objectPending',
    String: 'string',
    Relationship: 'relationship',
};

const dateOperators = [
    { label: 'Is', value: 'EQ' },
    { label: 'Is Not', value: 'NEQ' },
    { label: 'After', value: 'AFTER' },
    { label: 'Before', value: 'BEFORE' },
    { label: 'Between', requiresValueB: true, value: 'BETWEEN' },
];

const enumOperators = [
    { label: 'Is', value: 'EQ' },
    { label: 'Is Not', value: 'NEQ' },
];

const stringOperators = [
    { label: 'Contains', value: 'CONTAINS' },
    { label: 'Ends With', value: 'ENDS_WITH' },
    { label: 'Is', value: 'EQI' },
    { label: 'Is Not', value: 'NEQI' },
    { label: 'Starts With', value: 'STARTS_WITH' },
];

const intOperators = [
    { label: 'Is', value: 'EQ' },
    { label: 'Is Not', value: 'NEQ' },
];

const lookupOperators = [
    { label: 'Is', value: 'EQ' },
    { label: 'Is Not', value: 'NEQ' },
];

/**
 * Returns the operators for the given type.
 */
const getOperators = type => {
    switch (type) {
        case QueryBuilderAttributeTypes.String: return stringOperators;
        case QueryBuilderAttributeTypes.Int: return intOperators;
        case QueryBuilderAttributeTypes.Enum: return enumOperators;
        case QueryBuilderAttributeTypes.Date: return dateOperators;
        case QueryBuilderAttributeTypes.Lookup: return lookupOperators;
    }
    return [];
};

module.exports = {
    getOperators,
    QueryBuilderAttributeTypes,
    QueryBuilderConditions,
};
